export const QR_DIAG_SORT_FIELD = {
  REGISTERED_AT: 'registered_at',
  CREATED_ON_DEVICE_AT: 'created_on_device_at',
  BDE_TIMESTAMP: 'bde_timestamp',
  PRINTER_COMMISSION_DATE: 'printer_commission_date',
  PRINTER_MODEL: 'printer_model',
  PRINTER_SERIAL: 'printer_serial',
  PRINTER_COUNTRY: 'printer_country',
  PRINTER_LANGUAGE: 'printer_language',
  USER_EMAIL: 'user_email',
};
